export default __webpack_public_path__ + "static/media/loader.d0de97e3.svg";